import { Env, env } from "../utils/environment";

export const CLAUDE_CONNECTOR_UPDATED_AT = "2026-09-17";

/**
 * Canonical, assistant-neutral setup page. `/claude` and `/claude/privacy` stay alive as
 * back-compat aliases for links already shared, so never remove those pages.
 */
export const CONNECTOR_SETUP_ROUTE = "/connect";
export const CLAUDE_CONNECTOR_SCOPE = "notes:read notes:write";
export const PRODUCTION_CONNECTOR_URL = "https://prod-api.ideaflow.app/v1/mcp";
export const DEVELOPMENT_CONNECTOR_URL = "https://stage-api.ideaflow.app/v1/mcp";
// ts-prune-ignore-next
export const LOCAL_CONNECTOR_URL = "http://localhost:8081/v1/mcp";

// Official directory listing URLs, verified in signed-in sessions on 2026-09-17.
export const CLAUDE_DIRECTORY_LISTING_URL = "https://claude.ai/directory/ideaflow";
export const CLAUDE_DIRECTORY_URL = "https://claude.ai/directory";
export const CHATGPT_APP_LISTING_URL = "https://chatgpt.com/plugins/plugin_asdk_app_6a6c52a8e1688191bf2eb06d0d345c49";

export function getClaudeConnectorUrl(): string {
  if (env === Env.local) return LOCAL_CONNECTOR_URL;
  if (env === Env.dev || env === Env.preview) return DEVELOPMENT_CONNECTOR_URL;
  return PRODUCTION_CONNECTOR_URL;
}
